module.exports = __webpack_public_path__ + "static/media/galleryImg7.1310aab3.jpg";